<template>
    <v-app id="geolocation_listener">
        <!-- Overlay -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <SnackbarQV ref="SnackbarQV" />
        <v-card class="pa-6">
            <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">QuickGEO</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-select
                    style="max-width: 450px; max-height: 40px"
                    hide-details
                    dense
                    class="mt-6 mr-4"
                    dark
                    label="Filtra marker"
                    multiple
                    @change="cambioFiltroMArker"
                    :item-text="
                        (item) => `${item.matricola} - ${item.testo_nodo}`
                    "
                    item-value="id_nodo"
                    v-model="filtra_marker"
                    :items="markers"
                >
                </v-select>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="card_visible = !card_visible"
                            class="mr-2"
                            small
                            v-bind="attrs"
                            v-on="on"
                            ><v-icon :color="card_visible ? 'error' : 'primary'"
                                >mdi-card-bulleted-settings</v-icon
                            ></v-btn
                        >
                    </template>
                    <span>Lista marker</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="agg_marker == true"
                            class="mr-2"
                            @click="aggMarker"
                            small
                            v-bind="attrs"
                            v-on="on"
                            ><v-icon color="primary">mdi-plus</v-icon></v-btn
                        >
                    </template>
                    <span>Agg. Marker</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="updatePage()"
                            small
                            v-bind="attrs"
                            v-on="on"
                            ><v-icon color="primary">mdi-refresh</v-icon></v-btn
                        >
                    </template>
                    <span>Aggiorna</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="ml-2"
                            @click="setImpianto()"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="success">mdi-floppy</v-icon>
                        </v-btn>
                    </template>
                    <span>Salva Mappa</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goBack()" small v-bind="attrs" v-on="on"
                            ><v-icon color="error"
                                >mdi-keyboard-backspace</v-icon
                            ></v-btn
                        >
                    </template>
                    <span>Indietro</span>
                </v-tooltip>
            </v-toolbar>

            <div v-if="card_visible" class="container-card">
                <div v-for="(m, i) in markers" :key="i">
                    <div class="card-servizi">
                        <v-col>
                            <v-row justify="center" align="center">
                                <v-col cols="3" @click="openInfoWindow(m)">
                                    <div
                                        :style="{
                                            background: 'rgb(90, 145, 232)',
                                            border: '6px solid rgb(80, 80, 80)',
                                            borderRadius: '50px',
                                            height: '40px',
                                            width: '40px',
                                            boxShadow:
                                                'rgba(150, 150, 150, 0.9) 0px 4px 8px',
                                        }"
                                    >
                                        <div
                                            :style="{
                                                marginTop: '1px',
                                                marginLeft: '0.5px',
                                            }"
                                        >
                                            <span
                                                style="
                                                    font-size: 18px;
                                                    font-weight: bold;
                                                "
                                                >{{ i }}</span
                                            >
                                        </div>
                                    </div>
                                </v-col>
                                <v-col>
                                    <v-row>
                                        {{ m.testo_nodo }}
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-divider />
                            </v-row>
                            <v-row>
                                <v-col
                                    >{{ m.tipologia }} - {{ m.modello }} -
                                    {{ m.matricola }}</v-col
                                >
                            </v-row>
                            <v-row>
                                <v-divider />
                            </v-row>
                        </v-col>
                    </div>
                </div>
            </div>

            <div id="map"></div>

            <GmapMap
                ref="mapRef"
                name="d"
                :center="center"
                :zoom="16"
                :clickable="true"
                @click="clickMap"
                style="width: 100%; height: 70vh"
            >
                <GmapMarker
                    :key="index"
                    v-for="(m, index) in markers.filter(
                        (e) => e.id_nodo && filtra_marker.includes(e.id_nodo)
                    )"
                    :position="{
                        lat: m.latitudine,
                        lng: m.longitudine,
                    }"
                    :clickable="true"
                    :draggable="
                        m.latitudine1 != null && m.longitudine1 != null
                            ? false
                            : true
                    "
                    @dragend="dragEnd($event.latLng, m)"
                    :optimezed="true"
                    :animation="2"
                    @click="openInfoWindow(m)"
                    :icon="setMarkerIcon(m)"
                />

                <GmapInfoWindow
                    @closeclick="closeInfoWindow()"
                    @domready="setInfoWindow"
                    :position="{
                        lat: selectedMarker.latitudine,
                        lng: selectedMarker.longitudine,
                    }"
                    ref="infoWindow"
                    v-if="show_info_window === true"
                >
                    <v-card
                        style="margin: 0px; padding: 0px"
                        v-show="setted_info_window === true"
                        class="mx-auto overflow-hidden"
                    >
                        <v-toolbar color="indigo" dense>
                            <v-app-bar-nav-icon
                                dense
                                small
                                color="white"
                                @click.stop="drawer = !drawer"
                            >
                                <v-icon
                                    >mdi-dots-vertical</v-icon
                                ></v-app-bar-nav-icon
                            >
                            <v-toolbar-title class="white--text mr-12">
                                {{ selectedMarker.testo_nodo }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            @click="
                                                generateLink(selectedMarker)
                                            "
                                            v-on="on"
                                            v-bind="attrs"
                                            class="btn-c"
                                        >
                                            <v-icon
                                                style="margin-top: 2px"
                                                color="primary"
                                                >mdi-link-variant-plus</v-icon
                                            >
                                        </div>
                                    </template>
                                    <span>Generazione link</span>
                                </v-tooltip>
                            </div>
                            <span style="width: 10px" />
                            <v-spacer></v-spacer>
                            <div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            @click="clickChiudiInfoWindow"
                                            v-on="on"
                                            v-bind="attrs"
                                            class="btn-c"
                                        >
                                            <v-icon
                                                style="margin-top: 2px"
                                                color="error"
                                                >mdi-close</v-icon
                                            >
                                        </div>
                                    </template>
                                    <span>Chiudi</span>
                                </v-tooltip>
                            </div>
                        </v-toolbar>
                        <v-navigation-drawer
                            v-model="drawer"
                            absolute
                            temporary
                            width="140"
                        >
                            <v-list nav dense>
                                <v-list-item-group
                                    active-class="indigo--text text--accent-4"
                                >
                                    <v-list-item
                                        @click="clickModifica(selectedMarker)"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="primary"
                                                >mdi-pencil</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title
                                            >Modifica</v-list-item-title
                                        >
                                    </v-list-item>
                                    <v-divider></v-divider>
                                    <v-list-item
                                        :disabled="
                                            selectedMarker.tipologia ==
                                            'vehicle'
                                        "
                                        @click="clickElimina(selectedMarker)"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="error"
                                                >mdi-delete</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title
                                            >Elimina</v-list-item-title
                                        >
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-navigation-drawer>
                        <div class="ma-1">
                            <v-row justify="center" align="center" class="mt-3">
                                <v-col>
                                    <div
                                        :style="{
                                            backgroundImage:
                                                'url(' +
                                                selectedMarker.background_src +
                                                ')',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: '100% 100%',
                                            borderRadius: '5px',
                                            border: '1px solid white',
                                            boxShadow: '3px 6px 8px #bbb',
                                            display: 'inline-block',
                                            width: selectedMarker.width + 'px',
                                            height:
                                                selectedMarker.height + 'px',
                                        }"
                                    ></div>
                                </v-col>
                                <v-col
                                    v-if="
                                        selectedMarker.tipologia === 'vehicle'
                                    "
                                >
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-3"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.testo_nodo"
                                            label=" Nome Impianto"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-6"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.tipologia"
                                            label="Tipologia"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-col v-else cols="7">
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-3"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.testo_nodo"
                                            label=" Nome Impianto"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row class="mr-1 mt-4">
                                        <v-text-field
                                            class="mt-3"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.matricola"
                                            label="Matricola"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row class="mr-1 mt-4">
                                        <v-text-field
                                            class="mt-3"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.modello"
                                            label="Modello"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="
                                        selectedMarker.tipologia === 'vehicle'
                                    "
                                >
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-3"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.avg_speed"
                                            label="Velocità Avg"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-6"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.max_speed"
                                            label="Velocità Max"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="
                                        selectedMarker.tipologia === 'vehicle'
                                    "
                                >
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-3"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.distance"
                                            label="Distanza"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-6"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="selectedMarker.duration_on"
                                            label="Durata On"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="
                                        selectedMarker.tipologia === 'vehicle'
                                    "
                                >
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-3"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="
                                                selectedMarker.duration_moving
                                            "
                                            label="Durata Movimento"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row class="mr-1">
                                        <v-text-field
                                            class="mt-6"
                                            hide-details
                                            readonly
                                            dense
                                            v-model="
                                                selectedMarker.fuel_consumption
                                            "
                                            label="Consumo"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="mt-6">
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header
                                            color="indigo"
                                        >
                                            <span
                                                style="
                                                    font-size: 22px;
                                                    color: white;
                                                "
                                                >Informazioni Stato</span
                                            >
                                            <template v-slot:actions>
                                                <v-icon
                                                    class="mb-1"
                                                    color="white"
                                                >
                                                    $expand
                                                </v-icon>
                                            </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-data-table
                                                :headers="headers_result"
                                                :items="item_result"
                                                disable-sort
                                                class="elevation-4 mt-4"
                                                hide-default-footer
                                            >
                                                <template
                                                    v-slot:item="{ item }"
                                                >
                                                    <tr>
                                                        <td
                                                            v-for="(
                                                                colonna, index
                                                            ) in headers_result"
                                                            :style="
                                                                calcoloFormato(
                                                                    item,
                                                                    colonna
                                                                )
                                                            "
                                                            :key="index"
                                                        >
                                                            {{
                                                                item[
                                                                    colonna
                                                                        .value
                                                                ]
                                                            }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-row>
                        </div>
                    </v-card>
                </GmapInfoWindow>
            </GmapMap>
        </v-card>

        <!-- DIALOG LISTA MACCHINE -->
        <v-dialog width="80%" v-model="dialog_macchine">
            <v-toolbar color="indigo" dense>
                <v-toolbar-title>
                    <span class="white--text">Seleziona una Macchina</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                    solo
                    hide-details
                    dense
                    label="Cerca per descrizione"
                    v-model="filtra_lista_macchine"
                />
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="
                                dialog_macchine = false;
                                agg_marker = false;
                            "
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Chiudi</span>
                </v-tooltip>
            </v-toolbar>

            <v-data-table
                :headers="headers_macchine"
                :items="
                    filtra_lista_macchine != '' && filtra_lista_macchine != null
                        ? items_macchine.filter((e) =>
                              e.des_macchina.includes(filtra_lista_macchine)
                          )
                        : items_macchine
                "
                disable-sort
                class="elevation-6"
            >
                <template v-slot:[`item.select`]="{ item }">
                    <v-btn small @click="clickSelezionaMacchina(item)">
                        <v-icon color="primary">mdi-check</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <!-- Overlay -->
            <v-overlay :value="overlay2">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </v-dialog>

        <!-- DIALOG CREA MARKER  -->
        <v-dialog width="400" v-model="dialog_crea_marker">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title>
                        <span class="white--text">Aggiungi Macchina</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="salvaMarker(marker)"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiDialogMarker"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>

                <v-container>
                    <v-row justify="center" align="center">
                        <v-col cols="3">
                            <div
                                :style="{
                                    backgroundImage:
                                        'url(' + marker.background_src + ')',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: '100% 100%',
                                    borderRadius: '4px',
                                    boxShadow: '1px 6px 8px #bbb',
                                    display: 'inline-block',
                                    width: marker.width + 'px',
                                    height: marker.height + 'px',
                                }"
                            ></div>
                            <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="modificaImage()"
                    class="ml-3"
                    v-on="on"
                    v-bind="attrs"
                    small
                    dense
                    color="primary"
                    >mdi-image-plus</v-icon
                  >
                </template>
                <span>Modifica immagine</span>
              </v-tooltip> -->
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                class="ml-4"
                                hide-details
                                dense
                                v-model="marker.des_macchina"
                                label="Macchina"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
            <v-col cols="12">
              <v-select
                class="ma-1"
                :items="tipos"
                v-model="marker.id_tipo_get_macchina"
                dense
                label="Descrizione Tipo"
                item-text="des"
                item-value="id_tabella"
              />
            </v-col>
          </v-row> -->
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                class="ma-1"
                                v-model="marker.latitudine"
                                readonly
                                hide-details
                                dense
                                label="Latitudine"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                class="ma-1"
                                v-model="marker.longitudine"
                                readonly
                                hide-details
                                dense
                                label="Longitudine"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- <v-dialog width="unset" v-model="dialog_crea_marker">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title>
            <span class="white--text"> Aggiungi Impianto</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaMarker(marker)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip> 
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiDialogMarker" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-container>
          <v-row>
            <v-col cols="9">
              <v-row class="mt-1">
                <v-col cols="5">
                  <v-text-field
                    class="ma-1"
                    hide-details
                    dense
                    v-model="marker.testo_nodo"
                    label="Nome Impianto"
                  ></v-text-field>
                </v-col>
                <v-col cols="7">
                  <v-text-field
                    class="ma-1"
                    v-model="marker.latitudine"
                    readonly
                    hide-details
                    dense
                    label="Latitudine"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <v-text-field
                    class="ma-1"
                    hide-details
                    v-model="marker.des"
                    dense
                    label="Descrizione Tipo"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="7">
                  <v-text-field
                    class="ma-1"
                    v-model="marker.longitudine"
                    readonly
                    hide-details
                    dense
                    label="Longitudine"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3">
              <div
                :style="{
                  backgroundImage: 'url(' + selectedMarker.background_src + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '100% 100%',
                  borderRadius: '4px',
                  boxShadow: '3px 6px 8px #bbb',
                  display: 'inline-block',
                  width: selectedMarker.width + 'px',
                  height: selectedMarker.height + 'px',
                }"
              ></div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="modificaImage()"
                    class="ml-3"
                    v-on="on"
                    v-bind="attrs"
                    small
                    dense
                    color="primary"
                    >mdi-image-plus</v-icon
                  >
                </template>
                <span>Modifica immagine</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Query Marker
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="aggiungiQuery(marker)"
                      v-bind="attrs"
                      v-on="on"
                      small
                      light
                    >
                      <v-icon color="primary">mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi Query</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="salvaQuery"
                      class="ml-2"
                      v-bind="attrs"
                      v-on="on"
                      small
                      light
                    >
                      <v-icon color="success">mdi-floppy</v-icon>
                    </v-btn>
                  </template>
                  <span>Salva Query</span>
                </v-tooltip>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-data-table
                :headers="headers_estrazione"
                :items="marker.query.filter((e) => e.validita == 1)"
              >
                <template v-slot:item="{ item }">
                  <tr
                    class="record_tabella"
                    :data-deleted="item.error == 1 ? true : false"
                  >
                    <td>
                      <v-textarea
                        rows="3"
                        label="Testo Query"
                        v-model="item.query"
                      />
                    </td>
                    <td>
                      <v-text-field label="Label" v-model="item.label" />
                    </td>
                    <td style="text-align: left">
                      <v-select
                        style="display: inline-block; max-width: 200px"
                        :items="tipologia_query"
                        item-text="des"
                        item-value="value"
                        label="Seleziona"
                        v-model="item.predefinita"
                      ></v-select>
                    </td>
                    <td style="text-align: left">
                      <v-btn
                        :disabled="item.predefinita != 0"
                        @click="apriDialofFormato(item)"
                        small
                      >
                        <v-icon color="indigo">mdi-palette</v-icon>
                      </v-btn>
                    </td>
                    <td style="text-align: left">
                      <v-btn @click="playQuery(item)" small>
                        <v-icon color="primary">mdi-play</v-icon>
                      </v-btn>
                    </td>
                    <td style="text-align: left">
                      <v-btn @click="eliminaQuery(item)" small>
                        <v-icon color="error">mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog> -->

        <!-- DIALOG MODIFIA MARKER  -->
        <v-dialog width="800" v-model="dialog_edita_marker">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title>
                        <span class="white--text"> Modifica Impianto</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="modificaMarker()"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiDialogMarkerEdit"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>

                <v-container v-if="markerEdit">
                    <v-row justify="center" align="center">
                        <v-col cols="3">
                            <v-text-field
                                class="ma-1"
                                hide-details
                                readonly
                                dense
                                v-model="markerEdit.testo_nodo"
                                label="Nome Impianto"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                class="ma-1"
                                v-model="markerEdit.latitudine"
                                readonly
                                hide-details
                                dense
                                label="Latitudine"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                class="ma-1"
                                v-model="markerEdit.longitudine"
                                readonly
                                hide-details
                                dense
                                label="Longitudine"
                            ></v-text-field>
                            <!-- <v-col cols="5">
                  <v-autocomplete
                    background-color="#ffffff"
                    class="ma-1"
                    dense
                    hide-details
                    readonly
                    :items="tipologia_mezzi"
                    item-text="des_tipologia"
                    item-value="des_tipologia"
                    label="Descrizione Tipologia"
                    v-model="markerEdit.tipologia"
                  >
                  </v-autocomplete>
                </v-col> -->
                        </v-col>
                        <v-col cols="3">
                            <div
                                :style="{
                                    backgroundImage:
                                        'url(' +
                                        selectedMarker.background_src +
                                        ')',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: '100% 100%',
                                    borderRadius: '5px',
                                    border: '1px solid white',
                                    boxShadow: '3px 6px 8px #bbb',
                                    display: 'inline-block',
                                    width: selectedMarker.width + 'px',
                                    height: selectedMarker.height + 'px',
                                }"
                            ></div>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        @click="modificaImage()"
                                        class="ml-3"
                                        v-on="on"
                                        v-bind="attrs"
                                        small
                                        dense
                                        color="primary"
                                        >mdi-image-plus</v-icon
                                    >
                                </template>
                                <span>Modifica immagine</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-toolbar color="indigo" dense>
                                <v-toolbar-title class="white--text">
                                    Query Marker
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            @click="
                                                aggiungiQuery(selectedMarker)
                                            "
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            light
                                        >
                                            <v-icon color="primary"
                                                >mdi-plus</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Aggiungi Query</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            @click="salvaQuery"
                                            class="ml-2"
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            light
                                        >
                                            <v-icon color="success"
                                                >mdi-floppy</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Salva Query</span>
                                </v-tooltip>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <!-- <v-data-table
                :headers="headers_estrazione"
                :items="
                  selectedMarker.query
                    ? selectedMarker.query.filter((e) => e.validita == 1)
                    : null
                "
              >
                <template v-slot:item="{ item }">
                  <tr
                    class="record_tabella"
                    :data-deleted="item.error == 1 ? true : false"
                  >
                    <td>
                      <v-textarea
                        rows="3"
                        label="Testo Query"
                        v-model="item.query"
                      />
                    </td>
                    <td>
                      <v-text-field label="Label" v-model="item.label" />
                    </td>
                    <td style="text-align: left">
                      <v-select
                        style="display: inline-block; max-width: 200px"
                        :items="tipologia_query"
                        item-text="des"
                        item-value="value"
                        label="Seleziona"
                        v-model="item.predefinita"
                      ></v-select>
                    </td>
                    <td style="text-align: left">
                      <v-btn
                        :disabled="item.predefinita != 0"
                        @click="apriDialofFormato(item)"
                        small
                      >
                        <v-icon color="indigo">mdi-palette</v-icon>
                      </v-btn>
                    </td>
                    <td style="text-align: left">
                      <v-btn @click="playQuery(item)" small>
                        <v-icon color="primary">mdi-play</v-icon>
                      </v-btn>
                    </td>
                    <td style="text-align: left">
                      <v-btn @click="eliminaQuery(item)" small>
                        <v-icon color="error">mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table> -->
                            <v-container>
                                <v-row
                                    v-for="(item, i) in selectedMarker.query
                                        ? selectedMarker.query.filter(
                                              (e) => e.validita == 1
                                          )
                                        : []"
                                    :key="i"
                                >
                                    <v-row align="center" justify="center">
                                        <v-col cols="12">
                                            <QueryEditor
                                                v-model="item.query"
                                                :template="[]"
                                            />
                                        </v-col>
                                        <v-col cols="3">
                                            <!-- <v-select
                        style="display: inline-block; max-width: 200px"
                        :items="tipologia_query"
                        item-text="des"
                        item-value="value"
                        label="Seleziona"
                        v-model="item.predefinita"
                      ></v-select> -->
                                            <v-checkbox
                                                label="Query status"
                                                v-model="item.predefinita"
                                            />
                                        </v-col>
                                        <v-col cols="2">
                                            <v-btn
                                                :disabled="
                                                    item.predefinita == true
                                                "
                                                @click="apriDialofFormato(item)"
                                                small
                                            >
                                                <v-icon color="indigo"
                                                    >mdi-palette</v-icon
                                                >
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-btn
                                                @click="playQuery(item)"
                                                small
                                            >
                                                <v-icon color="primary"
                                                    >mdi-play</v-icon
                                                >
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-btn
                                                @click="eliminaQuery(item)"
                                                small
                                            >
                                                <v-icon color="error"
                                                    >mdi-delete</v-icon
                                                >
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-divider></v-divider>
                                        </v-col>
                                    </v-row>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <SnackbarQV ref="SnackbarQVQuery" />
            <!-- Overlay -->
            <v-overlay :value="overlay3">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </v-dialog>

        <!-- DIALOG ELIMINA MARKER  -->
        <v-dialog width="300" v-model="dialog_conferma_eliminazione">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title>
                        <span class="white--text">Conferma Eliminazione</span>
                    </v-toolbar-title>
                </v-toolbar>

                <v-container>
                    <v-row class="ma-4">
                        Vuoi eliminare
                        {{ selectedMarker ? selectedMarker.testo_nodo : null }}?
                    </v-row>

                    <v-divider></v-divider>
                    <v-row class="ma-0 pa-0">
                        <v-col style="text-align: right">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="annullaEliminazione"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="error">
                                            mdi-close
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Annulla</span>
                            </v-tooltip>
                        </v-col>
                        <v-col></v-col>
                        <v-col style="text-align: left">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="confermaElimina"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="success">
                                            mdi-check
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Conferma</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <SnackbarQV ref="SnackbarQV" />
        </v-dialog>
        <!-- Dialog di caricamento dei file immagine -->
        <v-dialog v-model="upload_file_visible" width="50%">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Carica Immagine</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="chiudiUploadFile"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text style="text-align: center" class="mt-5">
                    <v-file-input
                        accept="image/*"
                        @change="
                            uploadImage(img_upload_editor);
                            chiudiUploadFile();
                        "
                        style="display: inline-block; width: 400px"
                        type="file"
                        v-model="img_upload_editor"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- DIALOG ESTRAZIONE -->
        <v-dialog v-model="dialog_estrazione_visibile" width="75%">
            <v-card>
                <v-toolbar dense color="indigo" dark>
                    <v-toolbar-title> Risultato Estrazione </v-toolbar-title>
                </v-toolbar>
                <v-container>
                    <v-row class="mt-4" align="center" justify="center">
                        {{ result }}
                    </v-row>

                    <v-row align="center" justify="center">
                        <v-btn
                            class="ma-2"
                            @click="dialog_estrazione_visibile = false"
                        >
                            <v-icon color="success">mdi-check</v-icon>
                        </v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <FormatoQTT
            v-model="formato"
            :show="show_formato"
            :item="item_formato"
            @chiudi_dialg_formato="show_formato = false"
        />
        <SnackbarQV ref="SnackbarQV" />
    </v-app>
</template>

<script>
import GmapMap from "vue2-google-maps/dist/components/map.vue";
import Query from "@/classes/Query.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import FormatoQTT from "@/components/TABELLA_CUSTOM/FormatoQTT.vue";
import moment from "moment/moment";
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";

const scaledSize = { width: 40, height: 50, f: "px", b: "px" };

class Marker {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_padre", default_val: "" },
            { nome: "id_padre_temp", default_val: "" },
            { nome: "id_disegno", default_val: 1 },
            { nome: "des_disegno", default_val: "" },
            { nome: "id_modulo", default_val: "" },
            { nome: "tipologia", default_val: "" },
            { nome: "id_nodo", default_val: -1 },
            { nome: "id_nodo_temp", default_val: moment().valueOf() },
            { nome: "testo_nodo", default_val: "" },
            { nome: "categoria", default_val: "nodo_immagine" },
            { nome: "background_src", default_val: "" },
            { nome: "latitudine", default_val: 0 },
            { nome: "longitudine", default_val: 0 },
            { nome: "latitudine1", default_val: 0 },
            { nome: "longitudine1", default_val: 0 },
            { nome: "matricola", default_val: "" },
            { nome: "modello", default_val: "" },
            { nome: "query", default_val: [] },
            { nome: "validita", default_val: 1 },
            { nome: "width", default_val: 100 },
            { nome: "height", default_val: 100 },
            { nome: "duration_on", default_val: null },
            { nome: "duration_idle", default_val: null },
            { nome: "duration_moving", default_val: null },
            { nome: "max_speed", default_val: null },
            { nome: "avg_speed", default_val: null },
            { nome: "fuel_consumption", default_val: null },
            { nome: "distance", default_val: null },
        ];

        return campi;
    }
}

export default {
    name: "Geolocation",
    components: {
        GmapMap,
        SnackbarQV,
        FormatoQTT,
        QueryEditor,
    },
    data() {
        return {
            agg_marker: false,
            btn: document.getElementById("btnBlur"),
            // center: {
            //   lat: 44.251709200803234,
            //   lng: 7.785951060550503,
            // },
            center: {
                lat: 0,
                lng: 0,
            },
            drawer: false,
            marker: new Marker(),
            markers: [],
            tipos: [],
            dialog_crea_marker: false,
            dialog_edita_marker: false,
            dialog_estrazione_visibile: false,
            dialog_macchine: false,
            img_upload_editor: null,
            setted_info_window: false,
            show_info_window: false,
            dialog_conferma_eliminazione: false,
            selectedMarker: new Marker(),
            markerEdit: null,
            upload_file_visible: false,
            result: null,
            overlay: false,
            overlay2: false,
            overlay3: false,
            map: null,
            show_formato: false,
            formato: "",
            item_formato: {},
            filtra_lista_macchine: "",
            filtra_marker: [],
            card_visible: false,

            // Array
            headers_estrazione: [
                {
                    value: "query",
                    text: "Query",
                    sortable: false,
                    width: "300px",
                },
                { value: "label", text: "Label", sortable: false },
                { value: "select", text: "Tipologia", sortable: false },
                {
                    value: "formattazione",
                    text: "Formattazione",
                    sortable: false,
                },
                { value: "play", text: "Esegui", sortable: false },
                { value: "elimina", text: "Elimina", sortable: false },
            ],
            headers_macchine: [
                { value: "select", text: "Seleziona", sortable: false },
                {
                    value: "cod_macchina",
                    text: "Cod. Macchina",
                    sortable: false,
                },
                {
                    value: "des_macchina",
                    text: "Des. Macchina",
                    sortable: false,
                },
            ],
            headers_result: [],
            items_macchine: [],
            item_result: [],
            tipologia_query: [
                { des: "Colore", value: 1 },
                { des: "Standard", value: 0 },
            ],
            tipologia_mezzi: [
                { des_tipologia: "Gatto delle nevi", value: 1 },
                { des_tipologia: "Impianto sparaneve", value: 2 },
                { des_tipologia: "Funivia", value: 3 },
            ],
        };
    },
    computed: {},
    created() {},
    mounted() {
        // this.getImpianti();
        this.getMarkerPratoNevoso();
        // this.getTipo();
    },
    watch: {
        visible: {
            immediate: true,
            handler() {},
        },
    },
    methods: {
        async generateLink(marker) {
            let link =
                "https://www.google.com/maps/place/" +
                marker.latitudine +
                "," +
                marker.longitudine;
            try {
                await navigator.clipboard.writeText(link);
                this.$refs.SnackbarQV.print("success", `Link copiato`);
            } catch {
                window.open(link, "_blank");
            }
        },
        cambioFiltroMArker() {
            console.log("filtro_marker", this.filtra_marker);
        },
        aggMarker() {
            this.agg_marker = true;
            this.$refs.SnackbarQV.print(
                "success",
                "Clicca un punto sulla mappa"
            );
        },
        apriDialofFormato(item) {
            this.item_formato = item;
            this.formato = item.formato;
            this.show_formato = true;
        },
        aggiungiQuery(elem) {
            let query = new Query();
            query.id_nodo = elem.id_nodo;
            query.id_nodo_temp = elem.id_nodo;
            query.query = {};
            console.log("query: ", query);
            elem.query.push(query);
        },
        annullaEliminazione() {
            this.markerEdit = null;
            this.dialog_conferma_eliminazione = false;
        },
        calcoloFormato(valore_cella, colonna) {
            valore_cella = valore_cella[colonna.value];

            let formato = null;

            try {
                // il campo EXTRA è un json codificato in base64 (con supporto per UTF-8)
                formato = JSON.parse(
                    decodeURIComponent(escape(atob(colonna.formato)))
                );
            } catch (error) {
                return undefined;
            }

            let style = null;
            let valore_cella_cast;
            let tipo_dato;

            if (isFinite(Number(valore_cella)) && valore_cella != null) {
                valore_cella_cast = Number(valore_cella);
                tipo_dato = "numero";
            } else if (
                isFinite(Date.parse(valore_cella)) &&
                valore_cella != null
            ) {
                valore_cella_cast = Date.parse(valore_cella);
                tipo_dato = "data";
            } else {
                if (valore_cella == null) {
                    valore_cella_cast = "";
                } else {
                    valore_cella_cast = valore_cella.toString();
                }
                tipo_dato = "stringa";
            }

            const operazioni_numeriche = [
                function (item, test) {
                    return item < test;
                },
                function (item, test) {
                    return item <= test;
                },
                function (item, test) {
                    return item == test;
                },
                function (item, test) {
                    return item >= test;
                },
                function (item, test) {
                    return item > test;
                },
                function (item, test) {
                    return item != test;
                },
            ];

            const operazioni_stringa = [
                function () {
                    return false;
                },
                function () {
                    return false;
                },
                function (item, test, case_sensitive) {
                    if (case_sensitive == true) {
                        return item == test;
                    } else {
                        return item.toLowerCase() == test.toLowerCase();
                    }
                },
                function () {
                    return false;
                },
                function () {
                    return false;
                },
                function (item, test, case_sensitive) {
                    if (case_sensitive == true) {
                        return item != test;
                    } else {
                        return item.toLowerCase() != test.toLowerCase();
                    }
                },
            ];

            formato.forEach((regola) => {
                if (regola.static === true) {
                    style = regola.compiled_style;
                    return;
                }

                if (regola.range === true) {
                    switch (tipo_dato) {
                        case "numero":
                            if (
                                valore_cella_cast >= Number(regola.start_ref) &&
                                valore_cella_cast <= Number(regola.end_ref)
                            ) {
                                style = regola.compiled_style;
                                return;
                            }
                            break;
                        case "data":
                            if (
                                valore_cella_cast >=
                                    Date.parse(regola.start_ref) &&
                                valore_cella_cast <= Date.parse(regola.end_ref)
                            ) {
                                style = regola.compiled_style;
                                return;
                            }
                            break;
                    }
                } else {
                    switch (tipo_dato) {
                        case "stringa":
                            if (
                                operazioni_stringa[Number(regola.operation)](
                                    valore_cella_cast,
                                    regola.start_ref
                                )
                            ) {
                                style = regola.compiled_style;
                                return;
                            }
                            break;
                        case "numero":
                            if (
                                operazioni_numeriche[Number(regola.operation)](
                                    valore_cella_cast,
                                    Number(regola.start_ref)
                                )
                            ) {
                                style = regola.compiled_style;
                                return;
                            }
                            break;
                        case "data":
                            if (
                                operazioni_numeriche[Number(regola.operation)](
                                    valore_cella_cast,
                                    Date.parse(regola.start_ref)
                                )
                            ) {
                                style = regola.compiled_style;
                                return;
                            }
                            break;
                    }
                }
            });

            return style;
        },
        chiudiUploadFile() {
            this.upload_file_visible = false;
        },
        clickChiudiInfoWindow() {
            this.$refs.infoWindow.$emit("closeclick");
        },
        clickSelezionaMacchina(item) {
            console.log("macchina selezionata", item);
            this.marker.background_src = item.macchina_img;
            this.marker.des_macchina = item.des_macchina;
            this.marker.testo_nodo = item.des_macchina;
            this.marker.id_modulo = item.id_macchina;
            this.marker.tipologia = "Impianto";
            this.marker.modulo = "Macchina";
            this.dialog_crea_marker = true;
        },
        confermaElimina() {
            this.dialog_conferma_eliminazione = false;
            this.$refs.infoWindow.$emit("closeclick");

            this.markers.forEach((m) => {
                if (m.id_nodo_temp == this.markerEdit.id_nodo_temp) {
                    console.log("valorizzo a 0 la vlidita");
                    m.validita = 0;
                }
            });
            this.setImpianto();
            // this.setMacchinaImpianto(this.markerEdit);

            this.selectedMarker = new Marker();
        },
        chiudiDialogMarker() {
            // this.marker = new Marker();
            // this.selectedMarker = new Marker();
            this.dialog_crea_marker = false;
        },
        chiudiDialogMarkerEdit() {
            this.markerEdit = Object.assign({}, new Marker());
            this.dialog_edita_marker = false;
        },
        clickElimina(selectedMarker) {
            this.dialog_conferma_eliminazione = true;
            this.markerEdit = new Marker(selectedMarker);
        },
        clickModifica(selectedMarker) {
            this.markerEdit = new Marker(selectedMarker);
            this.dialog_edita_marker = true;
        },
        closeInfoWindow() {
            this.selectedMarker = new Marker();
            this.item_result = [];
            this.headers_result = [];
            this.show_info_window = false;
            this.setted_info_window = false;
        },
        clickMap(i) {
            if (this.agg_marker == false) return;

            this.getMacchine();
            this.dialog_macchine = true;

            if (
                this.selectedMarker.latitudine == 0 &&
                this.selectedMarker.longitudine == 0
            ) {
                console.log("this.selectedMarker - i", i, this.selectedMarker);
                this.marker.latitudine = i.latLng.lat();
                this.marker.longitudine = i.latLng.lng();
                // this.dialog_crea_marker = true;
                this.agg_marker = false;
            }
        },
        eliminaQuery(item) {
            item.validita = 0;

            this.$refs.SnackbarQV.print(
                "success",
                "Eliminazione della query avvenuta con successo."
            );
        },
        // eseguiQueryPredefinite() {
        //   // Raccolgo le query predefinite
        //   const arr_tmp = new Array();
        //   this.markers.forEach((m) => {
        //     if (m.query.length != 0) {
        //       m.query.forEach((q) => {
        //         if (q.predefinita === 1) {
        //           arr_tmp.push(Object.assign({}, q));
        //         }
        //       });
        //     }
        //   });

        //   // Mando la request con tutte le query predefinite
        //   let request = {
        //     controller: "Magazzino",
        //     method: "POST",
        //     richiesta: {
        //       action: "performquery",
        //       token: localStorage.user_token,
        //       query: arr_tmp,
        //     },
        //   };

        //   return this.$store
        //     .dispatch("api", request)
        //     .then((res) => {
        //       if (res.status === 200) {
        //         this.overlay = false;
        //         res.data.result.query.forEach((query) => {
        //           if (query.status_code == 200) {
        //             this.markers.forEach((marker) => {
        //               if (marker.id_nodo_temp == query.id_nodo_temp) {
        //                 marker.query.forEach((q) => {
        //                   if (q.id_nodo_query === query.id_nodo_query) {
        //                     q.result = query.result;
        //                     q.status_code = query.status_code;
        //                   }
        //                 });
        //               }
        //             });
        //           } else if (query.status_code == 204) {
        //             this.overlay = false;
        //             this.$refs.SnackbarQV.print(
        //               "orange",
        //               `Nessun risultato per la query: ${query.query}.`
        //             );
        //           } else {
        //             this.overlay = false;
        //             this.$refs.SnackbarQV.print(
        //               "orange",
        //               `Query non valida: ${query.result}.`
        //             );
        //           }
        //         });

        //         // this.nodi = _.cloneDeep(
        //         //   this.nodi_totali.filter(
        //         //     (elem) => elem.id_padre_temp === this.id_padre_temp_sel
        //         //   )
        //         // );
        //         return true;
        //       } else {
        //         this.overlay = false;
        //         return false;
        //       }
        //     })
        //     .catch(() => {
        //       return false;
        //     });
        // },
        eseguiQueryStandard(arg) {
            if (arg.query.length != 0) {
                let array_ids = [];

                arg.query.forEach((q) => {
                    if (q.titolo != "colore") {
                        array_ids.push(q.id_query);
                    }
                });

                let request = {
                    controller: "Magazzino",
                    method: "POST",
                    richiesta: {
                        action: "performquery",
                        token: localStorage.user_token,
                        id_oggetto: arg.id_modulo,
                        query_ids: array_ids.toString(),
                    },
                };

                this.$store.dispatch("api", request).then((res) => {
                    console.log("res perform standard", res);
                    this.item_result = [];
                    this.headers_result = [];
                    if (res.status === 200) {
                        let obj_item = [];
                        res.data.forEach((query) => {
                            console.log(query);
                            let formato_cella = "";
                            query.result.Table.forEach((e) => {
                                this.markers.forEach((m) => {
                                    m.query.forEach((q) => {
                                        if (q.id_query == query.id_query) {
                                            formato_cella = q.formato;
                                        }
                                    });
                                });
                                let name = Object.getOwnPropertyNames(e)[0];

                                let obj_header = {
                                    value: name,
                                    text: name.replaceAll("_", " "),
                                    formato: formato_cella,
                                };

                                obj_item.push(e);

                                this.headers_result.push(obj_header);
                            });
                        });
                        // let obj_conver = obj_item.reduce(function(result, item) {
                        // var key = Object.keys(item)[0]; //first property: a, b, c
                        // result[key] = item[key];
                        // })
                        let obj_tmp = {};
                        obj_item.forEach((e) => {
                            Object.keys(e).forEach((n) => {
                                obj_tmp[n] = e[n];
                            });
                        });

                        console.log("obj_conver==>", obj_tmp);

                        this.item_result.push(obj_tmp);

                        console.log(
                            "header - items =>",
                            this.headers_result,
                            this.item_result
                        );

                        // res.data.result.query.forEach((query) => {
                        //   if (query.status_code == 200) {
                        //     this.markers.forEach((marker) => {
                        //       if (marker.id_nodo_temp == query.id_nodo_temp) {
                        //         marker.query.forEach((q) => {
                        //           if (q.id_nodo_query === query.id_nodo_query) {
                        //             q.result = query.result;
                        //             q.status_code = query.status_code;
                        //           }
                        //         });
                        //       }
                        //     });

                        //     this.headers_result = [];

                        //     this.markers.forEach((marker) => {
                        //       if (
                        //         marker.id_nodo == arg.id_nodo &&
                        //         marker.query.length != 0
                        //       ) {
                        //         marker.query.forEach((q) => {
                        //           if (q.label != null && q.predefinita != 1) {
                        //             let obj_header = {
                        //               value: q.label,
                        //               text: q.label,
                        //               formato: q.formato,
                        //             };
                        //             this.headers_result.push(obj_header);
                        //           }
                        //           if (
                        //             q.result != null &&
                        //             q.label != null &&
                        //             q.predefinita != 1
                        //           ) {
                        //             this.item_result[q.label] = q.result;
                        //           }
                        //         });
                        //       }
                        //     });

                        //     console.log(
                        //       "headers, result",
                        //       this.headers_result,
                        //       this.item_result
                        //     );
                        //   } else if (query.status_code == 204) {
                        //     this.overlay = false;
                        //     this.snackbar = true;
                        //     this.snackbar_background = "orange";
                        //     this.snackbar_icon = "mdi-alert";
                        //     this.snackbar_icon_color = "white";
                        //     this.snackbar_text = `Nessun risultato per la query: ${query.query}.`;
                        //     this.snackbar_text_color = "white";
                        //   } else {
                        //     this.overlay = false;
                        //     this.snackbar = true;
                        //     this.snackbar_background = "error";
                        //     this.snackbar_icon = "mdi-alert";
                        //     this.snackbar_icon_color = "white";
                        //     this.snackbar_text = `Query non valida: ${query.result}.`;
                        //     this.snackbar_text_color = "white";
                        //     if (array_ids.length <= 1) {
                        //       this.blocca_drag = false;
                        //     }
                        //   }
                        // });
                    }
                });
            }
        },
        getMacchine() {
            this.overlay2 = true;
            const getlistamacchine = {
                controller: "Manutenzione",
                method: "POST",
                richiesta: {
                    action: "getlistamacchine",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store.dispatch("api", getlistamacchine).then((res) => {
                if (res.status === 200) {
                    this.overlay2 = false;
                    this.items_macchine = res.data.macchine;
                } else {
                    this.overlay2 = false;
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        goBack() {
            this.$router.push("/home");
        },
        openInfoWindow(m) {
            this.overlay = true;
            if (m.query.length != 0) {
                this.eseguiQueryStandard(m);
            }

            if (m.tipologia == "Impianto") {
                this.selectedMarker = new Marker(m);
                this.show_info_window = true;
                this.overlay = false;
            } else {
                let request = {
                    controller: "Esterno",
                    method: "POST",
                    richiesta: {
                        action: "getvehicledetail",
                        token: localStorage.getItem("user_token"),
                        id: m.id_modulo,
                    },
                };
                this.$store
                    .dispatch("api", request)
                    .then((res) => {
                        console.log("res vehicledetail: ", res);
                        if (res.status === 200) {
                            // Add the new fields in this obj

                            this.selectedMarker = new Marker(m);

                            let vehicle_tmp = {};

                            // res.data.result.data.forEach((elem) => {
                            //   if (elem.vehicle_state.avg_speed != 0) {
                            //     vehicle_tmp = elem;
                            //   }
                            // });

                            vehicle_tmp =
                                res.data.result.data[
                                    res.data.result.data.length - 1
                                ];

                            console.log("info vehicle", vehicle_tmp);

                            this.selectedMarker.avg_speed =
                                vehicle_tmp.vehicle_state.avg_speed;
                            this.selectedMarker.distance =
                                vehicle_tmp.vehicle_state.distance;
                            this.selectedMarker.duration_idle =
                                vehicle_tmp.vehicle_state.duration_idle;
                            this.selectedMarker.duration_moving =
                                vehicle_tmp.vehicle_state.duration_moving;
                            this.selectedMarker.duration_on =
                                vehicle_tmp.vehicle_state.duration_on;
                            this.selectedMarker.fuel_consumption =
                                vehicle_tmp.vehicle_state.fuel_consumption;
                            this.selectedMarker.max_speed =
                                vehicle_tmp.vehicle_state.max_speed;

                            this.show_info_window = true;
                            this.overlay = false;
                        } else {
                            this.overlay = false;
                            this.$refs.SnackbarQV.print(
                                "error",
                                `Ops, qualcosa è andato storto. Riprova.`
                            );
                        }
                    })
                    .catch(() => {
                        // Se ricevo un errore avviso l'Utente con una snackbar.
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "error",
                            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                        );
                    });
            }
        },
        // getImpianti() {
        //   let request = {
        //     controller: "Magazzino",
        //     method: "POST",
        //     richiesta: {
        //       action: "getmacchineprato",
        //       token: localStorage.getItem("user_token"),
        //     },
        //   };
        //   this.$store.dispatch("api", request).then((res) => {
        //     this.markers = res.data.result.macchine;
        //     this.markers.forEach((e) => {
        //       e.latitudine = parseFloat(e.latitudine);
        //       e.longitudine = parseFloat(e.longitudine);
        //     });
        //     console.log(this.markers);
        //   });
        // },
        getMarkerPratoNevoso() {
            this.overlay = true;
            let request = {
                controller: "Esterno",
                method: "POST",
                richiesta: {
                    action: "getresortsprato",
                    token: localStorage.getItem("user_token"),
                },
            };
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    console.log("res getresortsprato", res);

                    this.overlay = false;
                    this.markers = [];

                    // gestisco le coordinate perche le coordinate 1 hanno la priorità
                    res.data.result.nodi.forEach((m) => {
                        this.filtra_marker.push(m.id_nodo);
                        m.latitudine =
                            m.latitudine != null
                                ? parseFloat(m.latitudine.replace(",", "."))
                                : 45.06300340975711;
                        m.longitudine =
                            m.longitudine != null
                                ? parseFloat(m.longitudine.replace(",", "."))
                                : 7.679123994549478;

                        // m.latitudine = parseFloat(m.latitudine.replace(",", "."));
                        // m.longitudine =  parseFloat(m.longitudine.replace(",", "."));
                        console.log(
                            "m.longitudine-m.latitudine",
                            m.latitudine,
                            m.longitudine
                        );

                        if (m.query) {
                            m.query.forEach((q) => {
                                q.query = { query: q.query };
                                q.predefinita = q.titolo == "colore" ? 1 : 0;
                            });
                        } else if (m.query == undefined) {
                            m.query = new Array();
                        }
                    });

                    this.markers = res.data.result.nodi;
                    if (this.markers.length != 0) {
                        this.center.lat = this.markers[0].latitudine;
                        this.center.lng = this.markers[0].longitudine;
                    } else {
                        this.center.lat = 45.06300340975711;
                        this.center.lng = 7.679123994549478;
                    }

                    console.log("this.markers =>", this.markers);

                    // this.eseguiQueryPredefinite();
                })
                .catch((e) => {
                    console.error(e);
                    this.overlay = false;
                    this.center.lat = 45.06300340975711;
                    this.center.lng = 7.679123994549478;
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server."
                    );
                });
        },
        // getTipo() {
        //   let request = {
        //     controller: "Global",
        //     method: "POST",
        //     richiesta: {
        //       action: "gettabella",
        //       token: localStorage.getItem("user_token"),
        //       tipo: "TIPO_GET_MACCHINA",
        //       filter: "cod = 'PRTNVS' AND validita = 1",
        //     },
        //   };
        //   this.$store.dispatch("api", request).then((res) => {
        //     this.tipos = res.data;
        //   });
        // },
        modificaImage() {
            this.upload_file_visible = true;
        },
        modificaMarker() {
            this.markers.forEach((e) => {
                if (e.id_nodo == this.selectedMarker.id_nodo) {
                    e.background_src = this.selectedMarker.background_src;
                    e.width = this.selectedMarker.width;
                    e.height = this.selectedMarker.height;
                    e.tipologia = this.markerEdit.tipologia;

                    this.$refs.SnackbarQV.print(
                        "success",
                        "Modifiche salvate con successo."
                    );
                }
            });

            this.dialog_edita_marker = false;

            // this.setImpianto(markerEdit);
            // this.$refs.infoWindow.$emit("closeclick");
            // this.markerEdit = new Marker();
        },
        playQuery(item) {
            this.overlay3 = true;
            // item.query = item.query
            //   .replaceAll("\n", " ")
            //   .replaceAll("\r", " ")
            //   .replaceAll("\t", " ");
            // let arg = [];
            // arg.push(item);

            // this.selectedMarker.query.forEach((e) => {
            //   e.id_nodo = this.selectedMarker.id_nodo;
            // });

            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "performquery",
                    token: localStorage.user_token,
                    // id_oggetto: this.id_visualizzato,
                    query_string: item.query.query,
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    console.log(res);
                    this.overlay3 = false;
                    if (res.status === 200) {
                        this.result = res.data.result.Table[0];
                        this.dialog_estrazione_visibile = true;

                        // if (res.data.result.query[0].status_code == 200) {
                        //   this.result = item.label + ": " + res.data.result.query[0].result;
                        //   this.dialog_estrazione_visibile = true;
                        // } else if (res.data.result.query[0].status_code == 204) {
                        //   this.$refs.SnackbarQV.print(
                        //     "orange",
                        //     `Nessun risultato per la query: ${item.query}.`
                        //   );
                        // } else {
                        //   this.$refs.SnackbarQV.print(
                        //     "error",
                        //     `Query non valida: ${res.data.result.query[0].result}.`
                        //   );
                        // }
                    }
                })
                .catch(() => {
                    this.overlay3 = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        salvaMarker() {
            this.markers.push(this.marker);
            this.dialog_crea_marker = false;
            this.dialog_macchine = false;
            // SETMARKER
            this.marker = new Marker();
        },
        salvaQuery() {
            // Controllo che le query siano valorizzate nel modo corretto
            // ed evidenzio la riga della tabella nel caso in cui non lo fosse

            // let filter_marker = this.selectedMarker.query.filter(
            //   (e) => e.validita == 1
            // );
            // filter_marker.forEach((e) => {
            //   console.log("e", e);
            //   e.query = e.query
            //     .replaceAll("\n", " ")
            //     .replaceAll("\r", " ")
            //     .replaceAll("\t", " ");

            //   if (
            //     e.query.toLowerCase().includes("select") &&
            //     e.query.toLowerCase().includes("from") &&
            //     e.query.toLowerCase().includes("where") &&
            //     e.query != ""
            //   ) {
            //     console.log("query corretta");
            //     delete e.error;
            //     this.$refs.SnackbarQV.print("success", "Query salvate con successo.");
            //   } else if (
            //     e.query.toLowerCase().includes("select") &&
            //     e.query.toLowerCase().includes("from") &&
            //     !e.query.toLowerCase().includes("where")
            //   ) {
            //     console.log("query non corretta");
            //     e.error = 1;
            //     this.$refs.SnackbarQV.print(
            //       "orange",
            //       "Attenzione! Una o più query non hanno una condizione associata."
            //     );
            //   } else {
            //     console.log("query non corretta");
            //     e.error = 1;
            //     this.$refs.SnackbarQV.print("error", "Query non valide");
            //     return;
            //   }
            // });

            this.$refs.SnackbarQVQuery.print(
                "success",
                "Query salvate con successo."
            );
            this.markers.forEach((m) => {
                if (m.id_nodo == this.selectedMarker.id_nodo) {
                    console.log("match ids", m, this.selectedMarker);
                    m.query = this.selectedMarker.query;
                }
            });
        },
        setMacchinaImpianto(arg) {
            this.overlay = true;
            let arr = [];
            if (arg) {
                let macchina = {};

                macchina.id_macchina = arg.id_modulo;
                macchina.validita = 0;
                arr.push(macchina);
            } else {
                this.markers.forEach((m) => {
                    let macchina = {};
                    macchina.id_macchina = m.id_modulo;
                    // macchina.latitudine = m.latitudine.toString();
                    // macchina.longitudine = m.longitudine.toString();
                    macchina.latitudine = m.latitudine;
                    macchina.longitudine = m.longitudine;
                    macchina.query =
                        m.query.length != 0 ? m.query : [new Query()];
                    macchina.validita = 1;

                    // macchina.background_src = m.background_src ? m.background_src : "";
                    arr.push(macchina);
                });
            }

            let richiesta = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setmacchineprato",
                    token: localStorage.user_token,
                    macchine: arr,
                },
            };
            this.$store.dispatch("api", richiesta).then((res) => {
                if (res.status === 200) {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "success",
                        "Dati salvati con successo."
                    );
                    this.getMarkerPratoNevoso();
                } else {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
                // this.getImpianti();
            });
        },
        setImpianto() {
            this.show_info_window = false;
            this.overlay = true;

            this.markers.forEach((m) => {
                let new_query = new Array();
                m.query.forEach((q, i) => {
                    console.log("query q:", q);
                    let obj_query = {};
                    obj_query.formato = q.formato ? q.formato : "";
                    obj_query.id_nodo = q.id_nodo;
                    obj_query.id_nodo_temp = q.id_nodo;
                    obj_query.id_nodo_query =
                        q.id_query != null ? q.id_query : -1;
                    obj_query.label = q.predefinita == true ? "colore" : "";
                    obj_query.result = null;
                    obj_query.status_code = null;
                    obj_query.query = q.query.query;
                    obj_query.ordine = i;
                    obj_query.predefinita = q.predefinita == true ? 1 : 0;
                    obj_query.validita = q.validita;
                    console.log("obj query =>", obj_query);

                    new_query.push(obj_query);
                });

                m.query = new_query;
            });

            console.log("markers che mando", this.markers);

            // nodi_tmp.forEach((n) => {
            //   // n.latitudine = n.latitudine.toString();
            //   // n.longitudine = n.longitudine.toString();
            //   // n.query = n.query.length != 0 ? n.query : [new Query()];
            // });

            // nodi_tmp.forEach((e) => {
            //   if (e.query.length == 0) {
            //     e.query = [new Query()];
            //   }
            // });

            let request = {
                controller: "Plant",
                method: "PUT",
                richiesta: {
                    action: "setdisegno",
                    token: localStorage.user_token,
                    disegno: [
                        {
                            des_disegno: "",
                            id_disegno: 1,
                            nodi: this.markers,
                        },
                    ],
                },
            };
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Dati salvati con successo."
                        );

                        // PERCHE UNA SET MACCHINA?
                        this.setMacchinaImpianto();
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        setInfoWindow() {
            // Nascondo il pulsante standard di chiusura della infowindow
            document.getElementsByClassName(
                "gm-ui-hover-effect"
            )[0].style.opacity = 0;

            // Azzero i padding della infowindow
            document.getElementsByClassName("gm-style-iw-chr")[0].style.height =
                "0px";
            document.getElementsByClassName(
                "gm-style-iw"
            )[0].style.paddingBottom = "0px";
            document.getElementsByClassName(
                "gm-style-iw"
            )[0].style.paddingLeft = "0px";
            document.getElementsByClassName(
                "gm-style-iw"
            )[0].style.paddingRight = "0px";
            document.getElementsByClassName("gm-style-iw")[0].style.paddingTop =
                "0px";
            // document.getElementsByClassName("gm-style-iw-d")[0].style.width = "667px";
            document.getElementsByClassName("gm-style-iw-d")[0].style.overflow =
                "auto";

            // Registro di avere finito la configurazione della infowindow
            this.setted_info_window = true;
        },
        setMarkerIcon(marker) {
            if (marker.query == undefined) return;

            let query =
                marker.query.length != 0
                    ? marker.query.filter((q) => q.titolo == "colore")
                    : [];

            let colore =
                query.length != 0
                    ? query[0].result != null
                        ? query[0].result.includes("verde")
                            ? "verde"
                            : query[0].result.includes("rosso")
                            ? "rosso"
                            : query[0].result.includes("arancione")
                            ? "arancione"
                            : query[0].result.includes("giallo")
                            ? "giallo"
                            : "default"
                        : "default"
                    : "default";

            let icon = marker.testo_nodo.toLowerCase().includes("piattaforma")
                ? "piattaforma"
                : marker.testo_nodo.toLowerCase().includes("gru")
                ? "gru"
                : null;

            if (
                colore == "rosso" ||
                colore == "verde" ||
                colore == "giallo" ||
                colore == "arancione"
            ) {
                if (icon != null) {
                    return {
                        url: require(`../../assets/iconsMap/${
                            icon + colore
                        }.png`),
                        scaledSize,
                    };
                } else {
                    return {
                        url: require(`../../assets/iconsMap/${
                            "dafault" + colore
                        }.png`),
                        scaledSize,
                    };
                }
            } else {
                if (icon != null) {
                    return {
                        url: require(`../../assets/iconsMap/${
                            icon + "default"
                        }.png`),
                        scaledSize,
                    };
                } else {
                    return {
                        url: require(`../../assets/iconsMap/defaultmarker.png`),
                        scaledSize,
                    };
                }
            }
        },
        uploadImage(val) {
            let that = this;

            let reader = new FileReader();

            reader.onload = function () {
                // Registro l'immagine come Base64.

                let img = new Image();

                img.onload = function () {
                    /* Ora ho un'immagine di cui posso conoscere altezza e larghezza,
                     * e dimensiono il div in maniera da accoglierla senza stretcharla.
                     * Voglio che le dimensioni dell'immagine non siano mai
                     * superiori a 100 px; se lo sono scalo le dimesioni.*/
                    let w;
                    let h;

                    if (img.width >= img.height && img.width > 100) {
                        w = 100;
                        // Proporzione -> width_nuova : img.width = height_nuova : img.height
                        h = (w * img.height) / img.width;
                    } else if (img.height > img.width && img.height > 100) {
                        h = 100;
                        // Proporzione -> width_nuova : img.width = height_nuova : img.height
                        w = (h * img.width) / img.height;
                    } else {
                        w = img.width;
                        h = img.height;
                    }

                    /* Seleziono il nodo appena creato
                     * e apro il dialog di modifica. */
                    that.selectedMarker.background_src = img.src;
                    that.selectedMarker.width = w;
                    that.selectedMarker.height = h;
                };
                img.src = reader.result;
            };

            reader.onerror = function (error) {
                console.log("Error: ", error);
            };

            reader.readAsDataURL(val);
        },
        updatePage() {
            location.reload();
        },
        dragEnd(e, m) {
            this.selectedMarker = new Marker(m);
            this.selectedMarker.latitudine = e.lat();
            this.selectedMarker.longitudine = e.lng();

            this.markers.forEach((m) => {
                if (m.id_nodo_temp === this.selectedMarker.id_nodo_temp) {
                    m.latitudine = this.selectedMarker.latitudine;
                    m.longitudine = this.selectedMarker.longitudine;
                }
            });
        },
    },
};
</script>

<style scoped>
.record_tabella[data-deleted] {
    background-color: #ffcccc !important;
}

.record_tabella[data-deleted]:hover {
    background-color: #ffb3b3 !important;
}

.divider {
    width: 30px;
}

.btn {
    background-color: white;
    height: 28px;
    border-radius: 4px;
    box-shadow: 1px 2px 3px 0.5px rgb(172, 172, 172);
    text-align: center;
}

.btn:hover {
    transform: scale(1);
    display: block;
    background-color: #e9e6e6;
}

.btn-c {
    background-color: white;
    height: 28px;
    width: 45px;
    border-radius: 4px;
    text-align: center;
    /* margin-right: -4px; */
}

.btn-c:hover {
    transform: scale(1);
    display: block;
    background-color: #e9e6e6;
}

.button {
    width: 50px;
    margin: 5px;
}

.toolbar {
    background-color: #3f51b5;
    width: 150%;
    padding: 3px;
    margin-top: 0.2px;
    margin-right: 2px;
    border-radius: 4px;
}

.container-card {
    right: 25px;
    width: 350px;
    height: 80%;
    position: absolute;
    z-index: 999;
    overflow-y: auto;
    scrollbar-width: none;
    margin-top: 20px;
}

.card-servizi {
    border: 1px solid rgba(236, 236, 236, 0);
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.075) 100%
    );
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
        rgba(0, 0, 0, 0.399) 0px 3px 7px -3px;
    border-radius: 12px;
    backdrop-filter: blur(22px);
    -webkit-backdrop-filter: blur(22px);
    filter: brightness(0.9);
    margin: 10px;
    border-radius: 14px;
    box-shadow: rgba(0, 0, 0, 0.125) 0px 4px 14px;
    transition: 0.2s all;
}
</style>
